<template>
  <div class="public-main public-search">
    <div class="main_content mc-flex mc-flex-justify-between mc-items-center">
      <div class="mc-flex mc-items-center">
        <router-link to="/home">
          <img src="@/assets/images/logo.png" alt />
        </router-link>
        <div class="theme" v-if="topList.length > 0">
          <router-link
            :to="`/area?type=${item.styleType}&id=${item.cId}&name=${item.className}`"
            class="yellow-hover"
            v-for="(item, index) in topList"
            :key="index"
          >{{item.className}}</router-link>
          <!-- <router-link to="">更多</router-link> -->
          <el-popover
            class="theme-more"
            popper-class="theme-more"
            title
            placement="bottom-end"
            width="200"
            trigger="hover"
            v-if="topListMore.length > 0"
          >
            <div class="mc-flex mc-flex-wrap mc-ptb-5">
              <router-link
                :to="`/area?type=${item.styleType}&id=${item.cId}&name=${item.className}`"
                class="yellow-hover gray3-text mc-ml-15 mc-ptb-5"
                v-for="(item, index) in topListMore.length > 0 && topListMore"
                :key="index"
              >{{item.className}}</router-link>
            </div>
            <el-button slot="reference" class="mc-bold mc-size14 yellow-hover">更多</el-button>
          </el-popover>
        </div>
      </div>
      <div class="mc-flex mc-items-center">
        <div class="search mc-relative">
          <el-input placeholder="测温枪" v-model="input" class="input-with-select"
              @blur="hideSearchsuggest()"
              @focus="showSearchsuggest()"
              @input="showSearchsuggest()"
              @keyup.enter.native="searchKey">
            <!-- <el-select v-model="select" slot="prepend" placeholder="请选择">
              <el-option label="商品" value="1"></el-option>
              <el-option label="店铺" value="2"></el-option>
            </el-select>-->
            <div slot="append" class="mc-flex mc-flex-justify-center" @click="searchKey">
              <img src="@/assets/images/search.png" alt />
            </div>
          </el-input>
          <div class="searchsuggest-list" v-if="searchsuggestList.length>0">
              <ul class="result-list">
                  <li v-for="(item,index) in searchsuggestList">
                      <a :href="item.detailUrl">
                          <div class="text" v-html="item.productName"></div>
                      </a>
                  </li>
              </ul>
          </div>
          <div class="search-key mc-absolute mc-size12" v-if="searchWord.length > 0">
            <router-link
              :to="`/search?type=search&keys=${item}`"
              v-for="(item, index) in searchWord"
              :key="index"
            >{{item}}</router-link>
          </div>
        </div>
        <!-- <router-link
          class="cart mc-flex mc-items-center mc-flex-shrink gray3-text yellow-hover"
          :to="token ? '/cart' : '/login'"
        >
          <el-badge
            :value="cartInfo && cartInfo.productCount ? cartInfo.productCount : ''"
            class="mc-mr-10 mc-flex mc-flex-direction-column mc-items-center"
          >
            <img width="21px" height="19px" src="@/assets/images/cart.png" alt />
          </el-badge>我的购物车
        </router-link> -->
        <a href="https://www.qx.com/Account/Login" class="cart mc-flex mc-items-center mc-flex-shrink gray3-text yellow-hover" >
          <el-badge :value="cartInfo && cartInfo.productCount ? cartInfo.productCount : ''" class="mc-mr-10 mc-flex mc-flex-direction-column mc-items-center">
            <img width="21px" height="19px" src="@/assets/images/cart.png" alt />
          </el-badge>我的购物车
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      select: "商品",
      input: "",
      topList: [],
      topListMore: [],
      searchsuggestList: [],
      searchsuggestTimer: null,
      searchWord: [],
    };
  },

  // components: {},

  computed: {
    ...mapState({
      userInfo: "userInfo",
      token: "token",
      cartInfo: "cartInfo",
    }),
  },

  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.setSearchKey();
      },
      // 深度观察监听
      deep: true,
    },
  },
  mounted() {
    this.setSearchKey();
    if (this.token) {
      this.$store.dispatch("getCart");
    }
  },

  methods: {
    searchKey() {
      this.$router.push("/search?type=search&keys=" + encodeURIComponent(this.input));
    },
    // 判断搜索是否显示关键字
    setSearchKey(){
        if(this.$route.query.type=='search' && this.$route.query.keys){
            this.input = this.$route.query.keys;
        }else{
            this.input = '';
        };
    },
    async getTopList(type) {
      let post = {};
      if (type) {
        post = { type: 1 };
      }
      await this.$axios
        .post(this.$http.api + "/v1/community/navtopclasslist", post)
        .then((res) => {
          if (!res.code) {
            type ? (this.topListMore = res.data) : (this.topList = res.data);
          }
        });
    },
    // 显示搜索建议
    showSearchsuggest(val){
        clearTimeout(this.searchsuggestTimer);
        this.searchsuggestTimer = null;
        this.searchsuggestTimer = setTimeout(()=>{
            if(this.input){
                this.getSearchsuggest(val);
            }else{
                this.hideSearchsuggest();
            };
        }, 500);
    },
    // 隐藏搜索建议
    hideSearchsuggest(){
        setTimeout(()=>{
            this.searchsuggestList = [];
        }, 200);
    },
    async getSearchsuggest() {
        await this.$axios.post(this.$http.api + "/v1/index/searchsuggest", {key: this.input}, {showLoading: false}).then((res) => {
            if (!res.code) {
                this.searchsuggestList = res.data;
            }
        });
    },
    async getWord() {
      await this.$axios
        .post(this.$http.api + "/v1/index/getsearchword")
        .then((res) => {
          if (!res.code) {
            this.searchWord = res.data;
          }
        });
    },
    async getCart() {
      await this.$axios
        .post(this.$http.api + "/v1/cart/cartindexlist")
        .then((res) => {
          if (!res.code) {
            this.cartInfo = res.data;
          } else {
            this.cartInfo = "";
          }
        });
    },
  },
};
</script>
<style lang='less' scoped>
@import "~@/assets/css/less.less";
.public-search {
  background: @white;
  padding: 40px 0;
  .theme {
    margin-left: 15px;
    a {
      color: @gray3;
      padding: 0 25px;
      font-weight: bold;
    }
    .theme-more {
      button {
        background: none;
        border: none;
        color: @gray3;
      }
    }
  }
  .search {
    margin-right: 40px;
    /deep/.input-with-select {
      border: 2px solid @yellow;
      .el-input-group__prepend {
        width: 80px;
        border-radius: 0;
        border: none;
      }
      .el-input__inner {
        border: none;
        width: 300px;
      }
      .el-input-group__append {
        border: none;
        border-radius: 0;
        background: @yellow;
        width: 70px;
      }
    }
  }
  .searchsuggest-list {
      width: 304px;
      background-color: #fff;
      border: 2px solid #ffcc00;
      border-top: 0;
      position: absolute;
      left: 0;
      top: 44px;
      z-index: 10;
      .result-list li:hover {
          background-color: #f3f3f3;
      }
      .result-list li a {
          display: block;
          height: 28px;
          line-height: 28px;
          padding: 0 15px;
          font-size: 12px;
          color: #333;
          .text {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              /deep/em {
                  font-style: normal;
                  color: #ff0000;
              }
          }
      }
  }
  .search-key {
    top: 50px;
    a {
      color: @gray6;
      margin-right: 20px;
    }
  }
  .cart {
    /deep/.el-badge {
      .el-badge__content {
        background: @yellow;
        border: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Search.vue